import { render, staticRenderFns } from "./mobile-input-date.vue?vue&type=template&id=72b9fa72"
import script from "./mobile-input-date.vue?vue&type=script&lang=ts"
export * from "./mobile-input-date.vue?vue&type=script&lang=ts"
import style0 from "./mobile-input-date.vue?vue&type=style&index=0&id=72b9fa72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports